module.exports = __webpack_public_path__ + "img/attack_plant.6b8718ba.png";